if(!customElements.get('schock-mobile-purchase'))customElements.define('schock-mobile-purchase',class extends HTMLElement{
  connectedCallback(){
    this.product=this.closest('product-info');
    this.original=this.product?.querySelector('[id^="ProductSubmitButton-"]');
    if(!this.original)return;
    this.action=this.querySelector('[data-sticky-action]');
    this.sync=()=>{
      this.action.textContent=this.original.querySelector('span')?.textContent.trim()||'Įdėti į krepšelį';
      this.action.disabled=this.original.disabled||this.original.classList.contains('loading');
      this.querySelector('[data-sticky-price]').textContent=this.product.querySelector('.price__regular .price-item--regular')?.textContent.trim()||'';
      this.querySelector('[data-sticky-variant]').textContent=[...this.product.querySelectorAll('variant-selects input:checked')].map(x=>x.value).join(' / ');
      this.hidden=!!this.inView;
    };
    this.action.addEventListener('click',()=>this.original.click());
    this.observer=new MutationObserver(this.sync);
    this.observer.observe(this.product.querySelector('.product__info-wrapper'),{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','hidden','class']});
    this.intersection=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();});
    this.intersection.observe(this.original);this.sync();
  }
  disconnectedCallback(){this.observer?.disconnect();this.intersection?.disconnect();}
});
